<div class=" text-grey">
  <table class="table mb-0" *ngIf="gpuList?.length; else emptyMessage">
    <thead class="thead-dark newclass">
      <tr class="table-list-head">
        <th resizable>#</th>
        <th>vGPU Type</th>
        <th resizable>Name</th>
        <th resizable>Architecture</th>
        <th resizable>Memory Size</th>
        <th resizable>Max Instances</th>
        <th resizable>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr class="table-list-row" *ngFor="let gpu of gpuList, let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ gpu.pcIeId }}</td>
        <td>{{ gpu.productName }}</td>
        <td>{{ gpu.architecture }}</td>
        <td>{{ gpu.memorySize }}</td>
        <td>{{ gpu.maxInstances }}</td>
        <td class="controlActions">
          <!--<span class="bi bi-pencil-square" style="color: var(--s-primary-color); cursor: pointer;" (click)="manageGpu(gpu)" title="Manage GPU"></span>-->
          NA
        </td>
      </tr>
    </tbody>
  </table>
  <ng-template #emptyMessage><p class="emptyMessage">{{ noGPUMessage }}</p></ng-template>
</div>
